import { MobileMapPosition } from 'types/map/mobileMapPosition';

declare global {
  interface Window {
    dabeeo: any;
  }
}

// 모바일은 웹가는 다르게 현재위치가 변경되기 때문에 MapDraw class 에서 일괄적으로 기기 정보 저장함
class MapDraw {
  static get mapContainer() {
    return this._mapContainer;
  }

  private static _mapContainer: HTMLDivElement;

  static dabeeoMaps: any | null = null;

  static map: any = null;

  static mapData: any = null;

  static originFloorId = '';

  static originPointId = '';

  static originBuildingId = '';

  // mobile 지도 설정값
  static mobileMapPosition: MobileMapPosition = {
    coordinate: {
      x: 0,
      y: 0,
    },
    rotation: 0,
    centerPositionX: 0,
    centerPositionY: 0,
    zoom: 0,
    mapMinZoom: 0,
    mapMaxZoom: 0,
  };

  private mapOption = {
    camera: '2D', // 카메라 타입
    graphicLibrary: '3D', // 라이브러리 타입
    floor: MapDraw.originFloorId,
    language: 'ko',
    showPoi: true,
    spriteEnable: true,
    spriteKeepRotation: true,
    showWaterMarker: false,
    framerate: 30,
    controlOption: {
      rotate: MapDraw.mobileMapPosition.rotation,
      zoom: MapDraw.mobileMapPosition.zoom,
      tilt: 0,
      // 지도가 위치할 좌표
      pan: {
        x: Number(MapDraw.mobileMapPosition.centerPositionX),
        y: Number(MapDraw.mobileMapPosition.centerPositionY),
      },
    },

    enablePoiCollisionTest: false,
    dragDistance: 50,

    // DID에서 사용하려면 해당 옵션을 꺼줘야 함
    // Geo referencing 켜져있도록 사용하려면 해당 옵션 켜주고 OUTDOOR 우선으로 그려야함.
    enableGeoreferencing: false,

    backgroundImage: {
      visible: true,
    },
  };

  public static getInstance() {
    if (!this.dabeeoMaps) {
      this.dabeeoMaps = new window.dabeeo.Maps() as any;
    }

    return this.dabeeoMaps;
  }

  async showMap(mapContainer: HTMLDivElement) {
    MapDraw._mapContainer = mapContainer;

    MapDraw.map = await MapDraw.getInstance().showMap(mapContainer, this.mapOption, MapDraw.mapData);

    MapDraw.map.control.setOption({
      controlRangeOption: {
        zoom: {
          min: MapDraw.mobileMapPosition.mapMinZoom,
          max: MapDraw.mobileMapPosition.mapMaxZoom,
        },
      },
      mouseOption: {
        enableRotate: false,
        enableTilt: false,
      },
      touchOption: {
        enableZoom: true,
        enableRotate: false,
        enablePan: true,
        enableTilt: false,
      },
    });

    // 개발자도구 console 에서 접근 가능
    (window as any).mapDraw = MapDraw.map;
  }

  static cleanup() {
    if (MapDraw.map) {
      MapDraw.map.context.cleanup();
    }
  }
}

export default MapDraw;
